import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import ErrorPage from "commonComponents/errorPage/ErrorPage";
import { MetricsSkeleton, TableSkeleton } from "designV2/components/Skeleton";
import PageHeader from "designV2/components/PageHeader";
import EditShopForm from "./EditShopForm";
import "./editShop.css";

const GET_SHOP = gql`
  query getShopByShopAdmin {
    getShopByShopAdmin {
      _id
      state
      active
      acceptCash
      name
      address
      budget
      phoneNumbers
      origin
      preparingTime
      minimumPurchase
      newOrderSMSNotificationPhoneNumber
      newOrderSMSNotificationEnabled
      shopAdminReferralCode
      location {
        coordinates
      }
      workingHoursInMinutes {
        type
        from
        to
      }
      notWorkingDays {
        type
      }
      description
      bannerUrl
      logoUrl
      rootCategory {
        _id
        title
      }
      categories {
        _id
        title
      }
    }
  }
`;

// This screen is reached two different ways: the normal "Edit shop"
// item inside the dashboard (routes.js, plain `type` prop), and the
// standalone "your shop needs changes" page shown right after login
// when verification was rejected (layouts/shopAdmin/EditShop.js, which
// wraps this in its own card and passes editAfterRejection={true}).
// EditShopForm adapts its own chrome to whichever context it's in.
const EditShop = (props) => {
  const { loading, error, data, refetch } = useQuery(GET_SHOP, {
    fetchPolicy: "network-only",
  });

  if (loading) {
    return props.editAfterRejection ? (
      <TableSkeleton rows={6} columns={2} />
    ) : (
      <div className="page editShopPage">
        <main className="main">
          <PageHeader title="Shop settings" description="Loading your shop's details..." />
          <MetricsSkeleton count={4} />
          <TableSkeleton rows={6} columns={2} />
        </main>
      </div>
    );
  }

  if (error) {
    return <ErrorPage />;
  }

  return (
    <EditShopForm
      shop={data.getShopByShopAdmin}
      refetch={refetch}
      editAfterRejection={props.editAfterRejection}
    />
  );
};

export default EditShop;
